import { AnswerTypes } from "../types/questionVM";

const getAnswerTypeName = (id: number) => {
  switch (id) {
    case AnswerTypes.Text:
      return `Text`;
    case AnswerTypes.Phone:
      return `Phone`;
    case AnswerTypes.Checkbox:
      return `Checkbox`;
    case AnswerTypes.Multiline:
      return `Multiline Text`;
    case AnswerTypes.Dates:
      return `Important Dates`;
    case AnswerTypes.DateTime:
      return `Date/Time`;
    case AnswerTypes.MultipleChoice:
      return `Multiple Choice`;
    case AnswerTypes.Site:
      return `Site`;
    case AnswerTypes.Category:
      return `Category`;
    case AnswerTypes.Source:
      return `Source`;
    case AnswerTypes.Method:
      return `Communication Method`;
    case AnswerTypes.Status:
      return `Status/Type`;
    case AnswerTypes.Title:
      return `Title`;
    case AnswerTypes.Date:
      return `Date`;
    case AnswerTypes.Time:
      return `Time`;
    case AnswerTypes.WeeklyTask:
      return `Weekly Task`;
    case AnswerTypes.Section:
      return `Section`;
    case AnswerTypes.DateRange:
      return `Date Range`;
    case AnswerTypes.Confidential:
      return `Confidential`;
    case AnswerTypes.Job:
      return `Job`;
    default:
      return "";
  }
};

export default getAnswerTypeName;
